module.exports = "/images/it-88.svg?c929a296d9124c28d8920f83a6868c16";